// extracted by mini-css-extract-plugin
export var container = "dToNxLzf";
export var containerTypeHeading1 = "MhVxeNRm";
export var containerTypeHeading2 = "LcnZkRA1";
export var containerTypeBody1 = "uKnsLuGw";
export var containerTypeBody2 = "HimaTxlA";
export var containerTypeMeta1 = "gHI3ZB8e";
export var containerFontPrimary = "AbdQWhE7";
export var containerFontSecondary = "LRXBVXCy";
export var containerLineHeightNormal = "woFriZR0";
export var containerLineHeightSpaced = "KuwzNY9w";
export var containerLineHeightRelaxed = "X4+4YjQN";
export var containerColorLime = "ZWuDGXDw";
export var containerColorCactus = "h9j1FYx+";
export var containerColorRed = "_9bzA4HXG";
export var containerColorYellow = "YPnRRY4f";
export var containerColorDisabled = "Xsu-WVP4";
export var containerColorWhite = "CRfcyXIY";
export var containerColorGray = "S8Pm3qEh";
export var containerColorDarkviolet = "_17aAuj5H";
export var containerColorCharcoal = "JgHtghD3";
export var containerTransformNone = "iki0H8+L";
export var containerTransformUppercase = "_8NsAkxFN";
export var containerTransformLowercase = "_6f04GTqn";
export var containerTransformCapitalize = "O9xYv0fa";
export var containerAlignStart = "i0l+PkmX";
export var containerAlignCenter = "urBSehGb";
export var containerAlignEnd = "_19WHLrDS";
export var containerWeightNormal = "r2xKLPgi";
export var containerWeightBold = "_7jgZ5c0Y";